import { Col, Divider, Row } from "antd";
import React from "react";
import ResultChoices from "./ResultChoices";

interface Props {
  questions: any;
}
const ResultSurvey = ({ questions }: Props) => {
  return (
    <Row gutter={8} dir="rtl">
      <Col xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
        {questions
          ?.slice(0, Math.round(questions.length / 2))
          .map((question: any) => (
            <div className="takaful--question-content">
              <span className="takaful--content-services-request-span takaful--color-span">
                {question?.question}
              </span>
              <ResultChoices question={question} />
            </div>
          ))}
      </Col>
      <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}>
        <Divider
          type="vertical"
          className="takaful--survey-verticale-divider"
        />
      </Col>
      <Col xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
        {questions
          ?.slice(Math.ceil(questions.length / 2), questions.length)
          .map((question: any) => (
            <div className="takaful--question-content">
              <span className="takaful--content-services-request-span takaful--color-span">
                {question?.question}
              </span>
              <ResultChoices question={question} />
            </div>
          ))}
      </Col>
    </Row>
  );
};

export default ResultSurvey;
